var _defs, _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 111.28 113.62"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _title || (_title = /*#__PURE__*/React.createElement("title", null, "i4")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.57,51.34a25.67,25.67,0,1,1,25.67-25.67A25.69,25.69,0,0,1,85.57,51.34Zm0-47.92a22.25,22.25,0,1,0,22.25,22.25A22.27,22.27,0,0,0,85.57,3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.05,53.05H0V0H53.05ZM3.42,49.63H49.63V3.42H3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.66,111.24H7.4a5.78,5.78,0,0,1-5.13-8.43L21.4,65.88a5.77,5.77,0,0,1,10.25,0l19.13,36.93a5.77,5.77,0,0,1-5.12,8.43ZM26.53,66.18a2.32,2.32,0,0,0-2.09,1.27h0L5.31,104.39a2.33,2.33,0,0,0,.08,2.3,2.31,2.31,0,0,0,2,1.13H45.66a2.35,2.35,0,0,0,2.08-3.43L28.61,67.45A2.32,2.32,0,0,0,26.53,66.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.15,68.9c-4-3.18-7.88-4.4-11.67-3.64a13.25,13.25,0,0,0-7.36,4.63,12.27,12.27,0,0,0-6.85-4.62c-3.67-.8-7.55.42-11.57,3.63a15.64,15.64,0,0,0-6.05,14.17c.88,10.18,10,21.81,23.15,29.61l1.6.94,0,0,0,0,1.6-.94c13.17-7.8,22.27-19.43,23.15-29.61A15.63,15.63,0,0,0,105.15,68.9Zm-19,8.26.08-.2.61-1.35a13.1,13.1,0,0,1,1.38-2.39c1.33-2,3.5-4.24,6.19-4.76,2.4-.48,5.13.47,8.08,2.83a12.72,12.72,0,0,1,4.84,11.54c-.78,9.09-9,19.56-20.88,26.77-11.93-7.21-20.13-17.68-20.91-26.77a12.72,12.72,0,0,1,4.84-11.54c3-2.37,5.64-3.33,7.91-2.82,2.46.55,4.37,2.74,5.58,4.65"
  })))));
};

export default __webpack_public_path__ + "static/media/i4.ab8830fd.svg";
export { SvgComponent as ReactComponent };